import {INotamAI} from '@/firebase/airport';

// for format: 2024-12-24 23:00
export const toUTCDate = (dateString: string) => {
  'worklet';
  if (!dateString) return new Date();
  const parts = dateString.split(/[- :]/);
  return new Date(
    Date.UTC(
      parseInt(parts[0]),
      parseInt(parts[1]) - 1,
      parseInt(parts[2]),
      parseInt(parts[3]),
      parseInt(parts[4])
    )
  );
};

// for format: 24/12/2024 23:00
export const toUTCDateSecond = (dateString: string) => {
  'worklet';
  if (!dateString) return new Date();
  const parts = dateString.split(/[\\/\s:]/);
  const date = new Date(
    Date.UTC(
      parseInt(parts[2]),
      parseInt(parts[1]) - 1,
      parseInt(parts[0]),
      parseInt(parts[3]),
      parseInt(parts[4])
    )
  );
  return date;
};

export const checkNotamActiveByTime = (
  item: INotamAI,
  startTime: Date,
  endTime: Date
) => {
  'worklet';
  // 	active = "Active" if is_within_date_range(start_date, end_date) else "Inactive"
  // def is_within_date_range(start_date, end_date):
  //     if start_date == "" or end_date == "":
  //         return False
  //     today = datetime.utcnow()
  //     if end_date == "PERM":
  //         return start_date <= today
  //     return start_date <= today <= end_date
  let isActive = false;
  const startDate = item?.start_date?.replace(' : ', ':');
  const endDate = item?.end_date?.replace(' : ', ':');
  if (!startTime || !endTime) return 'Inactive';
  if (startDate === '' || endDate === '') {
    isActive = false;
  } else if (endDate === 'PERM' && startDate) {
    isActive = toUTCDateSecond(startDate) <= startTime;
  } else if (startDate && endDate) {
    isActive =
      toUTCDateSecond(startDate) <= startTime &&
      toUTCDateSecond(endDate) >= endTime;
  }
  return isActive ? 'Active' : 'Inactive';
};

export const checkNotamEffectiveByTimeWorklet = (
  item: INotamAI,
  etaStart: Date,
  etaEnd: Date
) => {
  'worklet';
  // if effectivity is null and active is Active, return true
  if (!item?.effectivity && item.active === 'Active') return true;
  // if active is Active and eta is null, return true
  if (item.active === 'Active' && !etaStart) return true;
  // if eta is null, return false
  if (!etaStart || !etaEnd) return false;

  // If effectivity periods are specified, set to Effective if eta is within any of the effectivity periods
  // e.g: [['08/03/2024 00:00', '08/03/2024 05:00'], ['09/03/2024 00:00', '09/03/2024 05:00']]
  const effectivity = item?.effectivity?.map((period) => {
    const start = toUTCDateSecond(period[0]);
    const end = toUTCDateSecond(period[1]);

    // Compare dates without time zone issues by using UTC methods
    return etaStart >= start && etaEnd <= end;
  });

  return effectivity?.includes(true) ?? false;
};
